import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import * as CustomerActions from '@ruby/modules/customer-select/store/actions/customers.actions';
import { IOrderFillViewDateRange, IOrderFillLocation, IOrderFillRequest } from '@ruby/modules/order-fill/model/order-fill.interface';
import { EOrderFillDateInterval, EOrderFillDateType } from '@ruby/shared/enums/order-fill.enums';
import * as OrderHistoryFiltersActions from '@ruby/shared/inventory-management/order-history-header/store/actions/order-history-filters.actions';
import * as fromOrderHistoryFilters from '@ruby/shared/inventory-management/order-history-header/store/reducers/order-history-filters.reducer';
import * as OrderHistoryFiltersSelectors from '@ruby/shared/inventory-management/order-history-header/store/selectors/order-history-filters.selectors';

@Component({
  selector: 'ng-order-history-header-container',
  templateUrl: './order-history-header.container.html',
  styleUrls: ['./order-history-header.container.scss']
})
export class OrderHistoryHeaderContainer implements OnInit, OnDestroy {
  @Input() customDateRange!: IOrderFillViewDateRange;
  @Output() selectedOrderFill = new EventEmitter<IOrderFillRequest>();
  store$: Observable<{ state: fromOrderHistoryFilters.State; customer?: ICustomer }>;
  selectedClassCode = '';
  customer?: ICustomer;
  subscription!: Subscription;

  constructor(private store: Store<fromOrderHistoryFilters.State>) {
    this.store$ = this.store.select(OrderHistoryFiltersSelectors.selectOrderFiltersState)
      .pipe(
        tap((st: {
          state: fromOrderHistoryFilters.State;
          customer?: ICustomer;
        }) => {
          if (st.customer) {
            if (!st.state.loadingLocations && st.state.locations.length === 0 && st.customer.masterPrimarySix && !st.state.error) {
              this.store.dispatch(OrderHistoryFiltersActions.loadLocations({ data: st.customer.masterPrimarySix }));
            }

            if (this.customer !== st.customer && st.customer.masterPrimarySix) {
              this.store.dispatch(OrderHistoryFiltersActions.resetState());
              this.customer = st.customer;
              this.store.dispatch(OrderHistoryFiltersActions.loadLocations({ data: st.customer.masterPrimarySix }));
            }

            if (st.customer.locations && st.customer.locations.length > 0 && st.customer.locations[0].classCode &&
              (this.selectedClassCode !== st.customer.locations[0].classCode)) {
              this.selectedClassCode = st.customer.locations[0].classCode;
            }
          }
        })
      );
  }

  ngOnInit(): void {
    this.store.dispatch(CustomerActions.loadCustomers());
  }

  ngOnDestroy(): void {
    this.store.dispatch(OrderHistoryFiltersActions.resetState());
  }

  /**
   * Select Pattern
   *
   * @summary Dispatch load patterns action
   * @param $selectedLocations: Array<IOrderFillLocation>
   * @returns void
   */
  selectPattern($selectedLocations: Array<IOrderFillLocation>): void {
    this.store.dispatch(OrderHistoryFiltersActions.loadPatterns({ data: $selectedLocations.map(loc => loc.locationId) }));
  }

  /**
   * Update Date Interval
   *
   * @summary Dispatch update date interval action
   * @param $date: { previous: EOrderFillDateInterval; current: EOrderFillDateInterval }
   * @returns void
   */
  updateDateInterval($date: { previous: EOrderFillDateInterval; current: EOrderFillDateInterval }): void {
    this.store.dispatch(OrderHistoryFiltersActions.updateDateInterval({ data: $date }));
  }

  /**
   * Selected Date Range
   *
   * @summary Dispatch update load date range action
   * @param $date: EOrderFillDateType
   * @returns void
   */
  selectedDateRange($date: EOrderFillDateType): void {
    this.store.dispatch(OrderHistoryFiltersActions.loadDateRange({ data: $date }));
  };
}
